import React from 'react';
import { Tab, Tabs } from '@mui/material';

export interface SubTabBarProps<T> {
  tabs: T[];
  selectedTab: number;
  setSelectedTab: (tabIndex: number, tabContent: T) => void;
  ariaLabel: string;
}

export function SubTabBar<
  T extends {
    id: string;
    label: string;
  },
>({ tabs, selectedTab, setSelectedTab, ariaLabel }: SubTabBarProps<T>): JSX.Element {
  return (
    <Tabs
      value={selectedTab}
      onChange={(_e, newTab) => setSelectedTab(newTab, tabs[newTab])}
      aria-label={ariaLabel}
      sx={{
        borderBottom: '1px solid',
        borderColor: 'primary.dark',
        '& .MuiTabs-flexContainer': {
          justifyContent: 'center',
        },
      }}
      TabIndicatorProps={{
        sx: {
          borderBottom: '4px solid',
          borderColor: 'primary.dark',
          background: 'none',
        },
      }}
    >
      {tabs.map((tab) => (
        <Tab
          key={tab.id}
          label={tab.label}
          id={tab.id}
          aria-controls={`tabpanel-${tab.id}`}
          disableRipple
          sx={{
            textTransform: 'initial',
            fontSize: '16px',
            opacity: 1,
            letterSpacing: 0.5,
            mt: 0,
            mb: 1.5,
            mx: 0.5,
            px: 1.5,
            py: 0.75,
            minWidth: { xs: 'auto', md: '250px', lg: '350px' },
            lineHeight: '24px',
            color: 'text.secondary',
            fontWeight: 500,
            minHeight: 'fit-content',
            '&.Mui-selected': {
              color: 'text.primary',
              fontWeight: 700,
            },
          }}
        />
      ))}
    </Tabs>
  );
}
